export enum BonusomatFilterValues {
    All = "",
    Uncompleted = "uncompleted",
    Completed = "completed",
    Repeating = "repeating",
}

export type BoardFilterOption = {
    // value used for v-model
    value: BonusomatFilterValues;
    // displayed text
    text: string;
};
